import axios, { AxiosInstance } from 'axios';

const localFallbackUrl = 'https://backend.licensing.xavier.blacksharktech.com';

const getRuntimeBackendUrl = (): string => {
  const hostname = window.location.hostname;
  const envHost = process.env.REACT_APP_IP;
  const isLocalHost = hostname === 'localhost' || hostname === '127.0.0.1';
  const isCloudFrontHost = /\.cloudfront\.net$/i.test(hostname);

  if (envHost) {
    return 'https://' + envHost;
  }

  if (isLocalHost || isCloudFrontHost) {
    return localFallbackUrl;
  }

  if (hostname.indexOf('backend.') === 0) {
    return 'https://' + hostname;
  }

  return 'https://backend.' + hostname;
};

const serverIpAddress: string = getRuntimeBackendUrl();

const axiosInstance: AxiosInstance = axios.create({
  baseURL: serverIpAddress
});

export default axiosInstance;



// WEBPACK FOOTER //
// ./src/common/axios-instance/axios-instance.ts